import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

interface SectionWrapperProps {
  instruction: string;
  children: ReactNode;
}

// Fixed height to ensure consistent modal size across all tabs (no scrolling)
const SECTION_HEIGHT = 520;

export const SectionWrapper = ({
  instruction,
  children,
}: SectionWrapperProps) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 2,
      height: SECTION_HEIGHT,
    }}
  >
    <Typography
      variant="body2"
      sx={{ color: "text.secondary", fontSize: "0.8rem" }}
    >
      {instruction}
    </Typography>
    {children}
  </Box>
);
